import styled from 'styled-components'

export const AlertMessageWrapper = styled.div`
  height: 1.25rem;
  padding-top: 0.2rem;
`
